import {mapActions, mapGetters} from 'vuex'
import CustomViewsFilter from '../components/CustomViewsFilter'

export default {
    components: {
        CustomViewsFilter
    },

    data() {
        return {
            isCustomViewModalActive: false,
            customViewToEdit: null,
        }
    },

    computed: {
        ...mapGetters([
            'allTableColumnsBySlug',
            'currentTableView',
            'tableViewsByType',
            'tableViewById',
            'canEditView',
            'tableViews'
        ]),

        customViewTableColumns() {
            let allTableColumns = this.allTableColumnsBySlug(this.tableName)

            return this.isView
                ? _.reduce(this.currentTableView.columns, (res, columnName) => {
                    let column = _.find(allTableColumns, {field: columnName})
                    if (column) res.push(column)
                    return res
                }, [])
                : this.tableColumns
        },

        isView () {
            return this.currentTableView
        }
    },

    watch: {
        'filters.table_view_id' (value) {
            return this.toggleTableView(value)
        },

        currentTableView() {
            this.fetchPaginatedData()
            this.rerenderTable()
        },

        tableViews () {
            if (! this.currentTableView) {
                this.filters.table_view_id = null
            }
        }
    },

    mounted() {
        this.fetchPaginatedData()
    },

    methods: {
        ...mapActions([
            'toggleTableView'
        ]),

        changeCustomView(viewId) {
            this.filters.table_view_id = viewId
            this.fetchPaginatedData(true)
        },

        openCustomViewModal (customViewId) {
            this.customViewToEdit = this.tableViewById(customViewId)
            this.isCustomViewModalActive = true
        },
    }
}